var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        "max-height": "auto",
        fullscreen: "",
        title: "人员分配",
        visible: _vm.dialogTableVisible,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogTableVisible = $event
        },
      },
    },
    [
      _c(
        "el-container",
        {
          staticClass: "person-select",
          staticStyle: { height: "calc(100vh - 200px)" },
        },
        [
          _c(
            "el-aside",
            { attrs: { width: "160px" } },
            [
              _c("el-tree", {
                ref: "postData",
                staticStyle: { width: "100%" },
                attrs: {
                  data: _vm.menus,
                  props: { children: "_child", label: "organize_name" },
                  "show-checkbox": "",
                  "node-key": "id",
                },
                on: { check: _vm.handlePostData },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-container",
            { staticClass: "el-menu" },
            [
              _c("el-main", [
                _c(
                  "div",
                  { staticClass: "search-group" },
                  [
                    _c("el-input", {
                      staticClass: "filter-item",
                      staticStyle: { width: "120px" },
                      attrs: { size: "mini", placeholder: "员工名称" },
                      model: {
                        value: _vm.query.username,
                        callback: function ($$v) {
                          _vm.$set(_vm.query, "username", $$v)
                        },
                        expression: "query.username",
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        staticClass: "filter-item",
                        attrs: {
                          type: "primary",
                          size: "mini",
                          icon: "el-icon-search",
                        },
                        on: { click: _vm.handleFilter },
                      },
                      [_vm._v("\n            搜索\n          ")]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticStyle: { margin: "20px 0" } },
                  [
                    _c(
                      "el-table",
                      {
                        ref: "multipleTable",
                        attrs: {
                          data: _vm.tableList,
                          "row-key": function (row) {
                            return row.id
                          },
                          stripe: "",
                        },
                        on: { "selection-change": _vm.handleSelectionChange },
                      },
                      [
                        _c("el-table-column", {
                          attrs: { type: "selection", width: "55" },
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            label: "姓名",
                            "min-width": "80",
                            prop: "username",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "transfer-box el-menu" }, [
            _c(
              "div",
              { staticStyle: { "margin-bottom": "10px" } },
              [
                _c("el-button", {
                  attrs: {
                    disabled: _vm.selectArr.length == 0,
                    type: "primary",
                    icon: "el-icon-arrow-right",
                    circle: "",
                  },
                  on: { click: _vm.toRight },
                }),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "el-container",
            [
              _c(
                "el-main",
                { staticClass: "selected-col" },
                [
                  _c("h3", { staticClass: "title" }, [_vm._v("已选人员")]),
                  _vm._v(" "),
                  _c(
                    "el-table",
                    {
                      ref: "multipleTable",
                      attrs: {
                        data: _vm.tableList2,
                        "row-key": function (row) {
                          return row.id
                        },
                        stripe: "",
                      },
                      on: { "selection-change": _vm.handleSelectionChange2 },
                    },
                    [
                      _c("el-table-column", {
                        attrs: { type: "selection", width: "55" },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: "姓名",
                          "min-width": "120",
                          prop: "username",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-footer",
                {
                  staticClass: "assign-select-footer",
                  staticStyle: { "line-height": "60px" },
                },
                [
                  _vm.seletedArr.length
                    ? _c(
                        "el-button",
                        {
                          attrs: { size: "small", type: "danger" },
                          on: { click: _vm.deletePerson },
                        },
                        [
                          _vm._v("\n          删除已选人员 "),
                          _c("span", [
                            _vm._v("(" + _vm._s(_vm.seletedArr.length) + "人)"),
                          ]),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small", type: "primary" },
                      on: { click: _vm.confirm },
                    },
                    [
                      _vm._v("确定添加 "),
                      _vm.select_number
                        ? _c("span", [
                            _vm._v("(" + _vm._s(_vm.select_number) + "人)"),
                          ])
                        : _vm._e(),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticStyle: {
            color: "#ff4001",
            "font-size": "14px",
            "margin-top": "20px",
          },
        },
        [
          _vm._v(
            "注：一个销售只能配备一个线上和一个线下的礼包，销售的礼包分配以最新的分配为主"
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }